import { render, staticRenderFns } from "./NavigationSubItem.vue?vue&type=template&id=747edb16"
import script from "./NavigationSubItem.vue?vue&type=script&lang=ts"
export * from "./NavigationSubItem.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports